import { __assign } from "tslib";
import initSchemaLoggerUsersEvents from '@wix/bi-logger-photo-users';
import initSchemaLoggerUsersOfUsersEvents from '@wix/bi-logger-photo-ugc';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import { baseUtils } from './baseUtils';
import Wix from '../sdk/WixSdkWrapper';
import window from '../sdk/windowWrapper';
var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
var omitEmails = function (obj, str) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            obj[key] = obj[key].replace(emailRegex, str);
        }
    }
};
var BiLogger = /** @class */ (function () {
    /* @ngInject */
    function BiLogger() {
        // this.initVisitorId();
        var factory = iframeAppBiLoggerFactory(Wix);
        this.biLoggerUsersEvents = initSchemaLoggerUsersEvents(factory)();
        this.biLoggerUsersOfusersEvents = initSchemaLoggerUsersOfUsersEvents(factory)();
        if (!baseUtils.isTest() && !baseUtils.isOOI()) {
            try {
                var galleryId = this.getParam('galleryId');
                this.biLoggerUsersEvents.util.updateDefaults({ gallery_id: galleryId });
                this.biLoggerUsersOfusersEvents.util.updateDefaults({
                    gallery_id: galleryId,
                });
            }
            catch (e) {
                console.error("getParam('galleryId'):", e);
            }
        }
        try {
            this.protocol = window.location.protocol;
            this.performance = window.performance;
        }
        catch (e) {
            this.protocol = 'http:';
            this.performance = false;
        }
        this.usersEvents = [
            'proGallerySettingsStartNow',
            'receivedMediaToUpload',
            'organizeMediaClickActionButton',
            'organizeMediaRearrangeGallery',
            'organizeMediaChangeSettings',
            'proGalleryDownloadLr',
            'addProGallery',
            'changeSettings',
            'mangeMediaUpperPanelOpen',
            'proGallerySettingsLoaded',
            'manageMediaSet',
            'manageMediaTextEditorCustomize',
            'uploadMedia',
            'uploadMediaError',
            'removeMedia',
            'layoutsSelect',
            'galleryPerformance',
            'proGallerySettingsNavigation',
            'galleryPublished',
            'customizeLayout',
            'organizeMediaEditQualityClick',
            'singleImageSettingsApply',
            'singleImageSettingsCancel',
            'organizeMediaReplaceImage',
            'manageMediaClick',
            'storeSetUpClick',
            'expandSettings',
            'expandModeDone',
            'watermarkSettings',
            'watermarkEnable',
            'cartSettings',
            'cartDesignTab',
            'artStoreDashboardNavigation',
            'artStoreSaveBusinessInfo',
            'artStoreStartNow',
            'artStoreChooseSellingMethod',
            'artStoreConnectProvider',
            'supportQuestionClick',
            'hover',
            'clickManageMediaButton', // 299
        ];
        this.usersOfusersEvents = [
            'share',
            'love',
            'download',
            'info',
            'expand',
            'paymentExcepted',
            'paymentError',
            'proGalleryLoadError',
            'proGalleryLoaded',
            'proGalleryErrorUou',
            'galleryClickOnItem',
            'galleryItemExpanded',
            'selectPhoto',
            'shareGroup',
            'buyBuyNowClick', // 800
        ];
        this.log = this.log.bind(this);
    }
    BiLogger.prototype.isUserEvent = function (funcName) {
        return this.usersEvents.includes(funcName);
    };
    BiLogger.prototype.isUserOfUserEvent = function (funcName) {
        return this.usersOfusersEvents.includes(funcName);
    };
    BiLogger.prototype.log = function (funcName, data) {
        if (data === void 0) { data = {}; }
        if (baseUtils.isOOI()) {
            return;
        }
        try {
            var initialData = {
                galleryType: this.getGalleryType(),
            };
            var logData = __assign(__assign({}, initialData), data);
            if (this.isUserEvent(funcName)) {
                if (funcName === 'manageMediaSet') {
                    omitEmails(data, '-omitted email-');
                }
                if (this.biLoggerUsersEvents[funcName]) {
                    this.biLoggerUsersEvents[funcName](logData);
                }
            }
            else if (this.isUserOfUserEvent(funcName)) {
                // logData = { ...logData, ...{ visitor_id: this.visitorId } };
                if (this.biLoggerUsersOfusersEvents[funcName]) {
                    this.biLoggerUsersOfusersEvents[funcName](logData);
                }
            }
            else {
                console.log('bi event is not categorized');
            }
        }
        catch (e) {
            console.log('Error bi logger', e);
        }
    };
    BiLogger.prototype.getGalleryType = function () {
        return baseUtils.isStoreGallery() ? 'store' : 'progallery';
    };
    BiLogger.prototype.initVisitorId = function () {
        var _this = this;
        // function is not working for OOI correctly
        if (baseUtils.isOOI()) {
            return;
        }
        if (typeof Promise === 'undefined') {
            console.error('promise is undefined in initVisitorId. Cant init visitor id');
            return;
        }
        var timeOut = 9000;
        var beginTime = Date.now();
        new Promise(function (resolve) {
            return resolve(Wix.Utils.getInstanceValue('aid') || Wix.Utils.getInstanceValue('uid'));
        })
            .then(function (val) {
            _this.visitorId = val;
            var interval = Date.now() - beginTime;
            if (interval > timeOut) {
                console.error("took over ".concat(timeOut, "ms to get the visitor id"), interval + 'ms');
            }
        })
            .catch(function (err) { return console.error('cant get visitorID/sessionToken', err); });
        setTimeout(function () {
            if (!_this.visitorId) {
                console.error("waiting ".concat(timeOut, "ms for visitorID/sessionToken"));
            }
        }, timeOut);
    };
    BiLogger.prototype.getParam = function (val) {
        var vmDefaultStringRegex = /^\$\{.*\}$/; // e.g. "${instance}" or "${some_variable}"
        var windowVal = String(window[val]);
        if (windowVal && vmDefaultStringRegex.exec(windowVal) === null) {
            return windowVal;
        }
        else {
            var result_1 = '', tmp_1 = [];
            location.search
                // .replace ( "?", "" )
                // this is better, there might be a question mark inside
                .substr(1)
                .split('&')
                .forEach(function (item) {
                tmp_1 = item.split('=');
                if (tmp_1[0] === val) {
                    result_1 = decodeURIComponent(tmp_1[1]);
                }
            });
            return result_1;
        }
    };
    return BiLogger;
}());
export var logger = new BiLogger();
//# sourceMappingURL=biLogger.js.map